var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 19,
    viewBox: "0 0 32 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.52344 0C2.3143 0 0.523438 1.79086 0.523438 4V15C0.523438 17.2091 2.3143 19 4.52344 19H27.7234C29.9326 19 31.7234 17.2091 31.7234 15V4C31.7234 1.79086 29.9326 0 27.7234 0H4.52344Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.08594 0C2.11842 0 0.523438 1.59499 0.523438 3.5625H31.7234C31.7234 1.59499 30.1285 0 28.1609 0H4.08594Z",
    fill: "#575DC1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.523438 15.4375C0.523438 17.405 2.11842 19 4.08594 19H28.1609C30.1285 19 31.7234 17.405 31.7234 15.4375H0.523438Z",
    fill: "#EBAA3E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.45575 11.5029C9.66956 10.9488 9.81966 10.5937 9.90813 10.4376L11.6855 7.125H12.9858L9.90813 12.6285H8.53414L8.01172 7.125H9.22561L9.43521 10.4376C9.44574 10.5503 9.45154 10.718 9.45154 10.9382C9.44522 11.197 9.43732 11.3854 9.42679 11.5029H9.45575Z",
    fill: "#5565AF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 12.6285L14.0339 7.125H15.2889L14.005 12.6285H12.75Z",
    fill: "#5565AF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1061 11.0818C19.1061 11.607 18.9023 12.0209 18.4973 12.3259C18.0913 12.6309 17.541 12.7831 16.8474 12.7831C16.2407 12.7831 15.753 12.6704 15.3828 12.4444V11.4128C15.9116 11.6836 16.4034 11.8195 16.8558 11.8195C17.1623 11.8195 17.403 11.767 17.5757 11.6595C17.7485 11.553 17.8348 11.4075 17.8348 11.221C17.8348 11.1136 17.8164 11.0187 17.7795 10.9368C17.7427 10.8558 17.6889 10.7797 17.621 10.7089C17.552 10.6385 17.3824 10.5113 17.1107 10.3248C16.7321 10.0757 16.4656 9.83097 16.3123 9.58668C16.158 9.34335 16.0817 9.08124 16.0817 8.79985C16.0817 8.47606 16.1659 8.18744 16.3365 7.93207C16.5061 7.67766 16.7478 7.47963 17.0628 7.33749C17.3767 7.19583 17.7374 7.125 18.1471 7.125C18.7417 7.125 19.2868 7.24931 19.7807 7.49746L19.332 8.37439C18.9044 8.18888 18.5094 8.09589 18.1471 8.09589C17.9186 8.09589 17.7327 8.15226 17.5878 8.26549C17.442 8.37824 17.3698 8.52809 17.3698 8.7136C17.3698 8.86682 17.4151 9.00077 17.5057 9.11448C17.5963 9.22868 17.799 9.37997 18.1145 9.56789C18.4457 9.76881 18.6948 9.99045 18.8591 10.2323C19.0234 10.4757 19.1061 10.758 19.1061 11.0818Z",
    fill: "#5565AF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0406 11.341H21.0947L20.3869 12.6511H19.0703L22.2217 7.125H23.7563L24.3609 12.6511H23.1391L23.0406 11.341ZM22.9785 10.3624L22.8716 9.0451C22.8436 8.71649 22.8305 8.39896 22.8305 8.09252V7.95712C22.7094 8.25827 22.5598 8.57724 22.3818 8.91308L21.6082 10.3624H22.9785Z",
    fill: "#5565AF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.bf083fcbfa9eaba025bacb14c55afab3.svg";
export { ForwardRef as ReactComponent };